'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GhostButton = require('./components/GhostButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GhostButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/ghost/index.js
// module id = 72
// module chunks = 0 1 2 3 4 5 6 7 8 9 10